import type { PackageType } from "@/features/operation-packages/api";

export const PACKAGE_TYPE_TO_GROUP: Partial<Record<PackageType, string>> = {
  // Apps
  AppUserCreation: "apps",
  BulkAppUserCreation: "apps",
  BulkAppUserDeactivation: "apps",
  MailAddressCreation: "apps",

  // Devices
  DeviceInventory: "devices",
  DeviceInventoryLabelCreation: "devices",
  EquipmentInventoryLabelCreation: "devices",
  EquipmentOrderRequest: "devices",
  EquipmentDamageAndLossReport: "devices",
};
